import { commentsData } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-3">吃瓜群众热评</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            来自真实用户的热门讨论，吃瓜社区精彩评论精选
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 max-w-5xl mx-auto">
          {commentsData.map((comment) => (
            <div key={comment.id} className="bg-background-100 rounded-xl border border-background-200/70 p-5 md:p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-foreground-800 overflow-hidden flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <div className="font-semibold text-sm text-foreground-900">{comment.name}</div>
                  <div className="text-xs text-foreground-500">{comment.date}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                "{comment.content}"
              </p>
              <div className="flex items-center gap-4 text-xs text-foreground-500">
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-600 transition-colors">
                  <i className="ri-thumb-up-line"></i> {comment.likes.toLocaleString()}
                </span>
                <span className="flex items-center gap-1 cursor-pointer hover:text-foreground-700 transition-colors">
                  <i className="ri-chat-1-line"></i> 回复
                </span>
                <span className="flex items-center gap-1 cursor-pointer hover:text-foreground-700 transition-colors">
                  <i className="ri-share-forward-line"></i> 分享
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}